import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';
import { ChartListSubscriber } from '@cbridge-packages/superset';
import { UserSettingsSection } from '@cbridge-packages/user-settings';
import { SidebarNavigationDrawer } from '@cbridge-modules/sidebar';
import { DashboardsSidebarFooter } from '@cbridge-fragments/dashboards/src/layout/DashboardsSidebarFooter';
import { useReportingNavigation } from '../_navigation/useReportingNavigation';

export const ReportingLayout: FunctionComponent = () => {
  const navigation = useReportingNavigation();

  return (
    <>
      <ChartListSubscriber />
      <SidebarNavigationDrawer
        defaultSidebarCollapsed={false}
        isCollapsible={true}
        settingsKey={UserSettingsSection.Reporting}
        isResizable={true}
        navigation={navigation}
        navigationBasePath={`/${RouteSegments.Root.Reporting}`}
        slots={{
          sidebarFooter: DashboardsSidebarFooter,
        }}
      />

      <Outlet />
    </>
  );
};
